import React from 'react';

interface BatteryBarProps {
  percentage: number; // 0-100
  width?: number;     // px
  height?: number;    // px
}

// Simple visual battery bar similar to mobile battery indicator
export default function BatteryBar({ percentage, width = 120, height = 28 }: BatteryBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(percentage)));
  const fillWidth = Math.max(2, Math.floor(((width - 8) * clamped) / 100));

  // Color from red (low) to green (high)
  const color = clamped < 20 ? '#ef4444' : clamped < 40 ? '#f59e0b' : clamped < 70 ? '#10b981' : '#22c55e';

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <div
        style={{
          position: 'relative',
          width,
          height,
          border: '2px solid #111827',
          borderRadius: 6,
          background: '#fff',
          boxSizing: 'border-box',
        }}
        aria-label={`Battery ${clamped}%`}
      >
        <div
          style={{
            position: 'absolute',
            right: -6,
            top: height / 4,
            width: 6,
            height: height / 2,
            background: '#111827',
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
          }}
        />
        <div
          style={{
            position: 'absolute',
            left: 4,
            top: 4,
            bottom: 4,
            width: fillWidth,
            background: color,
            borderRadius: 4,
            transition: 'width 150ms ease-in-out',
          }}
        />
      </div>
      <span style={{ fontSize: 12, color: '#374151', fontWeight: 600 }}>{clamped}%</span>
    </div>
  );
}


